import { UserRoles } from 'components/Auth/AuthProvider';

type NavigationDataProps = {
  elementId: number;
  navigationLevel: number;
  url: string;
  menuItem?: string;
  label: string;
  icon?: string;
  conditional?: boolean;
  restrictAccess?: UserRoles;
  children?: NavigationDataProps[];
  external?: boolean;
};

const navigationData: NavigationDataProps[] = [
  {
    elementId: 1,
    navigationLevel: 1,
    url: '/ferdabeidnir',
    label: 'Mínar beiðnir',
    icon: 'inbox',
    children: [],
  },
  {
    elementId: 2,
    navigationLevel: 1,
    url: '/samthykktir',
    label: 'Samþykktir',
    icon: 'contracts',
    conditional: true,
    children: [],
  },
  {
    elementId: 10,
    navigationLevel: 1,
    label: 'Umsjón',
    menuItem: 'Umsjón',
    url: '/admin',
    icon: 'settings',
    restrictAccess: 'travel-request-view',
    children: [
      {
        elementId: 11,
        label: 'Umsjón ferðabeiðna',
        url: '/admin/ferdabeidnir',
        navigationLevel: 2,
        restrictAccess: 'travel-request-view',
      },
      {
        elementId: 12,
        label: 'Samþykkjendur',
        url: '/admin/samthykkjendur',
        navigationLevel: 2,
        restrictAccess: 'travel-request-admin',
      },
      {
        elementId: 13,
        label: 'Tilkynningapóstar',
        url: '/admin/email',
        navigationLevel: 2,
        restrictAccess: 'travel-request-admin',
      },
      // {
      //   elementId: 13,
      //   label: 'Miðjan umsjón',
      //   url: 'https://midjan.landsvirkjun.is/umsysl',
      //   navigationLevel: 2,
      //   restrictAccess: 'travel-request-view',
      //   external: true,
      // },
    ],
  },
];

export default navigationData;
